import { OyResponse } from '@oy/types';
import { AUTH_MULTI_ACCOUNT_PREFIX, MULTI_ACCOUNT_PREFIX } from 'src/clients';

export const MULTI_ACCOUNT_MANAGEMENT_PARENT_URL = `${AUTH_MULTI_ACCOUNT_PREFIX}/parent`;
export const MULTI_ACCOUNT_MANAGEMENT_PARENT_BALANCE_URL = `${MULTI_ACCOUNT_PREFIX}/parent/balance`;

export type GetParentData = {
  relationId: string;
  parentUsername: string;
  logoUrl: string;
  status: string;
  parentAvatar: string;
};

export type GetParentBalanceData = {
  username: string;
  availableBalance: number;
  availableOverdraft: number;
  balance: number;
  pendingBalance: number;
  freezeBalance: number;
  totalChildAvailableBalance: number;
  totalChildBalance: number;
  totalChildOverdraftBalance: number;
  totalChildPendingBalance: number;
  totalChildFreezeBalance: number;
};

export type GetParentBalanceResponse = OyResponse<GetParentBalanceData>;
export type GetParentResponse = OyResponse<GetParentData>;
